import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Copy, Check, ArrowRight, Tag, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

const PromoFunnel = () => {
  const { code } = useParams();
  const nav = useNavigate();
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);
  const upper = (code || "").toUpperCase();

  useEffect(() => {
    let on = true;
    api.get(`/promo/${encodeURIComponent(upper)}`)
      .then((r) => { if (on) setInfo(r.data); })
      .catch(() => { if (on) setInfo({ code: upper, exists: false, valid: false, label: "" }); })
      .finally(() => { if (on) setLoading(false); });
    return () => { on = false; };
  }, [upper]);

  const copy = async () => {
    try { await navigator.clipboard.writeText(upper); } catch { /* noop */ }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const goToCourses = () => {
    try { sessionStorage.setItem("gca_promo", upper); } catch { /* noop */ }
    nav("/kurse");
  };

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-4 py-12 relative overflow-hidden" data-testid="promo-funnel">
      <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(60% 50% at 50% 0%, rgba(255,0,51,0.18) 0%, rgba(0,0,0,0) 70%)" }} />
      <div className="absolute inset-0 pointer-events-none opacity-[0.04]" style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60'%3E%3Cpath d='M0 0h60v60H0z' fill='none' stroke='%23fff' stroke-width='0.5'/%3E%3C/svg%3E\")" }} />

      <div className="relative w-full max-w-md">
        <div className="flex flex-col items-center text-center mb-8">
          <img src="/logo.png" alt="Golfcoaching Academy Wendlingen" className="h-16 w-auto mb-2" data-testid="promo-logo"
               onError={(e) => { e.currentTarget.outerHTML = '<div class=\"font-heading text-xl uppercase tracking-tight\">Golfcoaching Academy</div>'; }} />
        </div>

        {loading ? (
          <div className="flex justify-center py-16"><Loader2 className="animate-spin text-[#ff0033]" /></div>
        ) : (
          <div className="border border-white/10 bg-[#0A0A0A] p-8 relative">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#ff0033] px-3 py-1 font-mono-lab text-[10px] uppercase tracking-widest">Exklusive Aktion</div>

            {info?.valid ? (
              <>
                <div className="flex items-center justify-center gap-2 text-[#ff0033] mb-2 mt-2"><Tag size={18} /><span className="font-mono-lab text-xs uppercase tracking-widest">Dein Rabatt</span></div>
                <div className="text-center font-heading text-5xl sm:text-6xl uppercase leading-none mb-6" data-testid="promo-label">{info.label}</div>

                <p className="text-center text-neutral-400 text-sm mb-3">Sichere dir deinen Vorteil auf unsere Golfkurse. Nutze diesen Code an der Kasse:</p>

                <button onClick={copy} data-testid="promo-copy" className="group w-full border-2 border-dashed border-[#ff0033]/60 bg-[#111] py-4 px-4 flex items-center justify-between hover:border-[#ff0033] transition-colors mb-6">
                  <span className="font-heading text-2xl tracking-widest text-white" data-testid="promo-code">{upper}</span>
                  <span className="flex items-center gap-1.5 font-mono-lab text-[11px] uppercase tracking-widest text-[#ff0033]">
                    {copied ? <><Check size={15} /> Kopiert</> : <><Copy size={15} /> Kopieren</>}
                  </span>
                </button>

                <button onClick={goToCourses} data-testid="promo-cta" className="w-full bg-[#ff0033] text-white font-heading uppercase tracking-wider py-4 hover:bg-[#cc0029] transition-colors flex items-center justify-center gap-2">
                  Jetzt Kurs sichern <ArrowRight size={18} />
                </button>
                <p className="text-center text-neutral-600 text-[11px] mt-3">Der Code wird beim Buchen automatisch vorausgefüllt – einfach an der Kasse anwenden.</p>
              </>
            ) : (
              <div className="text-center py-4">
                <div className="font-heading text-3xl uppercase mb-3">Aktion nicht verfügbar</div>
                <p className="text-neutral-400 text-sm mb-6">Dieser Aktionscode ist aktuell nicht (mehr) gültig. Schau dir aber gerne unsere aktuellen Golfkurse an.</p>
                <button onClick={() => nav("/kurse")} data-testid="promo-cta" className="w-full bg-[#ff0033] text-white font-heading uppercase tracking-wider py-4 hover:bg-[#cc0029] transition-colors flex items-center justify-center gap-2">
                  Zu den Kursen <ArrowRight size={18} />
                </button>
              </div>
            )}
          </div>
        )}

        <p className="text-center text-neutral-600 text-[11px] mt-6">© {new Date().getFullYear()} Golfcoaching Academy Wendlingen</p>
      </div>
    </div>
  );
};

export default PromoFunnel;
